import { Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";
import { AvatarSize } from "./Type/AvatarType";

@Component({
  selector: "app-avatar",
  standalone: true,
  imports: [NgClass],
  templateUrl: "./AvatarComponent.html",
  styleUrl: "./AvatarComponent.scss",
})
export class AppAvatarComponent {
  @Input() imageUrl: string | null = null;
  @Input() name = "";
  @Input() size: AvatarSize = "md";

  get initials(): string {
    const trimmedName = this.name.trim();

    if (!trimmedName) {
      return "?";
    }

    const parts = trimmedName.split(/\s+/);
    const firstInitial = parts[0]?.charAt(0) ?? "";
    const lastInitial = (() => {
      if (parts.length > 1) {
        return parts[parts.length - 1]?.charAt(0) ?? "";
      }
      return "";
    })();
    const initials = `${firstInitial}${lastInitial}`;

    return initials.toUpperCase();
  }

  get sizeClass(): string {
    return `app-avatar--${this.size}`;
  }
}
